export default "__VITE_ASSET__BXp$1U0N__"